import type { Message } from 'react-hook-form';

/**
 * FormError class
 * This class is used to represent errors returned from the custom validation in the frontend.
 * It extends the Error class and adds additional properties to it.
 */
export class FormError extends Error {
  public type = 'api';

  public message: Message = '';

  public key = '';

  constructor(key: string, message: Message, type = 'custom') {
    super(message);
    this.key = key;
    this.message = message;
    this.type = type;
  }
}
